import React from 'react'
import { ProductTypeProps, Maybe } from '.'
import { DigitalDataOrigin } from '../utils/digital-data-types'
import { Card } from './product-card-gallery-composable'
import type { Props as HeadingProps } from '@dustin-web/microsite-components/src/heading'

type Props = {
  imagePriority?: boolean
  product?: Maybe<ProductTypeProps>
  ticket: string
  digitalDataOrigin: DigitalDataOrigin
  digitalIndex?: number
  hTag?: HeadingProps['hTag']
}

const ProductCardEol = ({
  product,
  ticket,
  imagePriority = false,
  digitalDataOrigin,
  digitalIndex = 0,
  hTag = 'h3',
}: Props) => {
  if (!product) {
    return null
  }
  return (
    <Card.Container
      customClassName="u-mb-16"
      product={product}
      digitalIndex={digitalIndex}
      digitalDataOrigin={digitalDataOrigin}>
      <div className="c-box c-product-card c-product-card--eol t-nullify">
        <Card.Picture
          product={product}
          ticket={ticket}
          imagePriority={imagePriority}
          digitalDataIndex={digitalIndex}
          digitalDataOrigin={digitalDataOrigin}
        />
        <div className="c-product-card-content align-items-center flex-row">
          <div className="flex-grow-1 u-mr-8 d-flex flex-column justify-content-between">
            <Card.Title
              className="u-mb-12"
              product={product}
              ticket={ticket}
              digitalDataIndex={digitalIndex}
              digitalDataOrigin={digitalDataOrigin}
              hTag={hTag}
            />
          </div>
          <div className="d-flex flex-column justify-content-between">
            <Card.Price
              isAvailableForSale={product.availability?.isAvailableForSale}
              price={product.price}
              displayVatInfo={false}
            />
          </div>
        </div>
      </div>
    </Card.Container>
  )
}

export default ProductCardEol
